import React, { useCallback } from 'react';
import { Box } from 'rebass';
import { UtilityIconButton } from '../Button/UtilityIconButton';
import { ThirdPaneHook } from './index';

const ThirdPaneToggle = (props: ThirdPaneHook): JSX.Element => {
  const { onToggle, visible } = props;

  const onClick = useCallback(() => {
    if (onToggle) {
      onToggle(!visible);
    }
  }, [onToggle, visible]);

  return (
    <Box
      className="third-pane-toggle"
      py={1}
      pr={[1, 2, 2]}
      sx={{
        position: [undefined, undefined, 'absolute'],
        top: [undefined, undefined, 2],
        right: '100%',
        transition: [undefined, undefined, 'all .3s ease'],
        '&:hover': {
          cursor: 'pointer',
        },
      }}
      onClick={onClick}
    >
      <UtilityIconButton icon="x" dark />
    </Box>
  );
};

export default ThirdPaneToggle;
